import { render, staticRenderFns } from "./DocumentsPatients.vue?vue&type=template&id=189e9d23"
import script from "./DocumentsPatients.vue?vue&type=script&lang=js"
export * from "./DocumentsPatients.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports